import React from "react";
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid-pro";

/**
 * Simple DataGrid toolbar without search or filters (using custom filter system).
 * The built-in MUI export button is intentionally omitted — export is handled
 * by this app's custom EditUpload export feature instead.
 */
const SimpleToolbar = React.memo(() => {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
    </GridToolbarContainer>
  );
});

SimpleToolbar.displayName = "SimpleToolbar";

export default SimpleToolbar;
